import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "uk-overflow-auto" }
const _hoisted_2 = { class: "uk-text-small uk-text-small uk-table-middle uk-table uk-table-small uk-table-divide uk-table-small uk-table-striped uk-table-justify uk-table-middle uk-table-hover" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "file-select" }
const _hoisted_7 = ["onChange"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadDetailModal = _resolveComponent("LoadDetailModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      isOpen: _ctx.isLoadDetailsOpen,
      "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoadDetailsOpen) = $event)),
      modalId: "pod-load-details-modal",
      maxWidth: "6xl",
      onClose: _ctx.closeLoadDetails
    }, {
      content: _withCtx(() => [
        (_ctx.selectedLoad)
          ? (_openBlock(), _createBlock(_component_LoadDetailModal, {
              key: 0,
              load: _ctx.selectedLoad
            }, null, 8, ["load"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isOpen", "onClose"]),
    _createElementVNode("table", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "uk-table-shrink" }, "#"),
          _createElementVNode("th", { class: "uk-table-shrink uk-text-center" }, "Load"),
          _createElementVNode("th", { class: "uk-text-center" }, "Status"),
          _createElementVNode("th", { class: "uk-text-center" }, "Driver"),
          _createElementVNode("th", { class: "uk-text-center" }, "Customer"),
          _createElementVNode("th", { class: "uk-text-center" }, "Document"),
          _createElementVNode("th", { class: "uk-table-middle uk-text-center" }, "Created"),
          _createElementVNode("th", { class: "uk-table-middle uk-text-center" }, "Last Updated"),
          _createElementVNode("th")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loads, (load) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: load.id,
            onClick: ($event: any) => (_ctx.selectLoad(load.id))
          }, [
            _createElementVNode("td", null, _toDisplayString(load.id), 1),
            _createElementVNode("td", null, [
              _createElementVNode("b", null, _toDisplayString(load.loadDocumentId), 1)
            ]),
            _createElementVNode("td", null, _toDisplayString(load.status), 1),
            _createElementVNode("td", null, _toDisplayString(load.driver.fullName || '---'), 1),
            _createElementVNode("td", null, _toDisplayString((load.customer && load.customer.name) || '---'), 1),
            (_ctx.uploadLoading)
              ? (_openBlock(), _createElementBlock("td", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("span", {
                    "uk-spinner": "",
                    "uk-tooltip": "Uploading POD"
                  }, null, -1)
                ]))]))
              : (load.podFileUrl !== null)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("a", {
                      "uk-icon": "icon: file-pdf",
                      "uk-tooltip": "View POD",
                      href: load.podFileUrl,
                      target: "_blank"
                    }, null, 8, _hoisted_5)
                  ]))
                : (_openBlock(), _createElementBlock("td", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("label", _hoisted_6, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          "uk-icon": "icon: upload",
                          "uk-tooltip": "Upload POD manually"
                        })
                      ], -1)),
                      _createElementVNode("input", {
                        type: "file",
                        onChange: event => _ctx.uploadPOD(load.driver.id, load.id, event)
                      }, null, 40, _hoisted_7)
                    ])
                  ])),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatDatetime(load.createdAt)), 1),
            _createElementVNode("td", null, _toDisplayString(load.lastUpdatedAt && _ctx.formatDatetime(load.lastUpdatedAt) || '---'), 1),
            (_ctx.tableType === 'active')
              ? (_openBlock(), _createElementBlock("td", {
                  key: 3,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("a", {
                    "uk-icon": "icon: check",
                    "uk-tooltip": "Archive Load",
                    onClick: ($event: any) => (_ctx.archiveLoad(load.id))
                  }, null, 8, _hoisted_8)
                ]))
              : (_ctx.tableType === 'archived')
                ? (_openBlock(), _createElementBlock("td", {
                    key: 4,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("a", {
                      "uk-icon": "icon: refresh",
                      "uk-tooltip": "Un-archive Load",
                      onClick: ($event: any) => (_ctx.unarchiveLoad(load.id))
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}